// Danish number format: 1.234.567 - same separators as the server's da-DK culture.
const formatter = new Intl.NumberFormat('da-DK', { maximumFractionDigits: 0 });

/**
 * "1.234.567", with optional prefix/suffix for whatever the number is measured in:
 * formatDanishNumber(x, { suffix: ' kr/md' }), formatDanishNumber(x, { prefix: 'kr. ' }),
 * formatDanishNumber(x, { suffix: ' DKK' }), formatDanishNumber(x, { suffix: ' m²' }).
 */
export function formatDanishNumber(
  value: number | null | undefined,
  { prefix = '', suffix = '' }: { prefix?: string; suffix?: string } = {},
): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '';

  return `${prefix}${formatter.format(value)}${suffix}`;
}
